module.exports = __webpack_public_path__ + "img/shopping-bag-third.c71b45a6.svg";